import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const de: AppStrings = {
  // COMMON
  error_title: 'Fehler',
  cancel: 'Abbrechen',
  retry: 'Erneut versuchen',
  back_arrow: '← Zurück',

  // ASK SCREEN
  ask_box_unavailable: 'Box nicht verfügbar',
  ask_box_unavailable_desc: 'Der Link ist möglicherweise veraltet oder der Inhaber hat die Box geschlossen.',
  ask_create_own_box: 'Eigene Box erstellen',
  ask_sent_title: 'Gesendet ✅',
  ask_sent_desc: 'Deine anonyme Frage wurde an den Box-Inhaber übermittelt.',
  ask_anonymous_hint: 'Deine Frage wird anonym gesendet.',
  ask_placeholder: 'Schreib deine Frage…',
  ask_send: 'Senden',
  ask_sending: 'Wird gesendet…',
  ask_error_rate_limit: 'Zu viele Anfragen — bitte warte eine Minute.',
  ask_error_restart: 'Bitte starte die Mini App neu.',
  ask_error_load: 'Box konnte nicht geladen werden.',
  ask_error_send: 'Frage konnte nicht gesendet werden.',
  ask_error_banned: 'Du bist in der App gesperrt.',
  ask_banned_appeal_btn: 'Einspruch',
  ask_appeal_sent: 'Einspruch eingereicht. Wir prüfen ihn manuell.',

  // AGE GATE
  age_gate_title: 'Nur für 18+',
  age_gate_desc:
    'Du sendest eine anonyme Frage. Bitte bleib respektvoll: Belästigung, Drohungen, sexuelle Inhalte mit Minderjährigen und gesetzeswidrige Inhalte sind verboten. Anonymität bedeutet keine Straffreiheit — Verstöße werden der Moderation gemeldet. Mit dem Senden bestätigst du, dass du 18+ bist und die Regeln akzeptierst.',
  age_gate_confirm: 'Ich bin 18+ — weiter',

  // INBOX SCREEN
  inbox_title: 'Deine Box',
  box_link_accordion: 'Einladungslink',
  inbox_notifications_ask: '🔔 Soll der Bot dich über neue Fragen benachrichtigen?',
  inbox_notifications_allow: 'Erlauben',
  inbox_notifications_dismiss_label: 'Schließen',
  inbox_box_toggle_disable: 'Fragen deaktivieren',
  inbox_box_toggle_enable: 'Fragen aktivieren',
  inbox_box_disabled_warning: 'Fragen sind deaktiviert — es werden keine neuen Fragen angenommen.',
  inbox_share_hint: 'Teile den Link, damit Freunde dir anonyme Fragen stellen können.',
  inbox_copy: 'Kopieren',
  inbox_copied: 'Kopiert',
  inbox_copy_error: 'Fehler',
  inbox_no_deeplink: 'Link erscheint nach dem Deploy.',
  inbox_invite_story: 'Per Story einladen',
  inbox_invite_chat: 'Per Chat einladen',
  inbox_card_rendering: 'Einladungskarte wird noch erstellt.',
  inbox_story_unsupported:
    'Stories sind in dieser Telegram-Version nicht verfügbar. Versuche „per Chat".',
  inbox_story_error: 'Story konnte nicht geöffnet werden.',
  inbox_chat_unsupported:
    'Chat-Teilen ist in dieser Telegram-Version nicht verfügbar. Aktualisiere den Client.',
  inbox_chat_error: 'Teilen fehlgeschlagen. Bitte versuche es erneut.',
  inbox_chat_prepare_error: 'Einladung konnte nicht vorbereitet werden.',
  inbox_filter_incoming: 'Eingehend',
  inbox_filter_hidden: 'Versteckt',
  inbox_filter_blocked: 'Blockiert',
  inbox_filter_empty: 'Hier ist noch nichts.',
  inbox_acc_unanswered: 'Unbeantwortet',
  inbox_acc_answered: 'Beantwortet',
  inbox_acc_hidden: 'Versteckt',
  inbox_acc_blocked: 'Blockiert',
  inbox_empty: 'Noch keine Fragen. Teile den Link oben.',
  inbox_load_more: 'Mehr laden',
  inbox_load_more_error: 'Nächste Seite konnte nicht geladen werden.',
  inbox_error_load: 'Box konnte nicht geladen werden.',
  inbox_rate_limit: 'Zu viele Anfragen — bitte warte eine Minute.',
  inbox_toggle_error: 'Box-Status konnte nicht geändert werden.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Schreib mir anonym',
  message_placeholder: 'Schreib eine Nachricht…',
  message_anonymous_hint: 'Deine Nachricht wird anonym gesendet.',
  message_sent_title: 'Gesendet ✅',
  message_sent_desc: 'Deine anonyme Nachricht wurde zugestellt.',
  message_owner_entry: 'Schreib mir',
  message_share_hint: 'Teile den Link, damit dir jeder eine anonyme Nachricht schicken kann.',
  message_inbox_open: 'Erhaltene Nachrichten',
  message_inbox_title: 'Nachrichten',
  message_inbox_empty: 'Noch keine Nachrichten. Teile deinen Link oben.',

  // ANSWER SCREEN
  answer_title: 'Frage beantworten',
  answer_placeholder: 'Schreib deine Antwort…',
  answer_submit: 'Senden',
  answer_submitting: 'Wird gesendet…',
  answer_back: 'Zurück',
  answer_error_send: 'Antwort konnte nicht gesendet werden.',

  // SHARE SCREEN
  share_title: 'Antwort veröffentlicht ✅',
  share_hint: 'Teile die Karte und sammle noch mehr Fragen.',
  share_card_rendering_desc:
    'Die Karte wird noch erstellt. Geh zurück zu den Fragen und schau kurz später nach — du kannst sie dann in einer Story oder im Chat teilen.',
  share_card_alt: 'Antwortkarte',
  share_story_btn: 'In Story teilen',
  share_story_btn_busy: 'Öffne…',
  share_chat_btn: 'Im Chat teilen',
  share_chat_btn_busy: 'Bereite vor…',
  share_back: 'Zurück zu Fragen',
  share_story_unsupported:
    'Stories sind in dieser Telegram-Version nicht verfügbar. Versuche „Im Chat teilen".',
  share_story_error: 'Story konnte nicht geöffnet werden. Versuche „Im Chat teilen".',
  share_chat_sent: 'Nachricht gesendet.',
  share_chat_unsupported:
    'Chat-Teilen ist in dieser Telegram-Version nicht verfügbar. Aktualisiere den Client.',
  share_chat_error: 'Teilen fehlgeschlagen. Bitte versuche es erneut.',
  share_chat_prepare_error: 'Nachricht konnte nicht vorbereitet werden.',

  // LEADERBOARD SCREEN
  lb_title: 'Rangliste',
  lb_period_7d: '7 Tage',
  lb_period_30d: '30 Tage',
  lb_period_all: 'Alle Zeit',
  lb_group_label: 'Kategorie',
  lb_group_all: 'Alle',
  lb_group_ask: 'Fragen',
  lb_group_rate: 'Bewertung',
  lb_group_confession: 'Geständnis',
  lb_group_guesswho: 'Wer ist es?',
  lb_group_message: 'Nachrichten',
  lb_error: 'Rangliste konnte nicht geladen werden',
  lb_empty: 'Noch niemand in der Rangliste',
  lb_anon: 'Anonym',
  lb_load_more: 'Mehr laden',
  lb_questions: (n) => plural('de', n, { one: '{n} Frage', other: '{n} Fragen' }),
  lb_referrals: (n) => plural('de', n, { one: '{n} Ref.', other: '{n} Refs.' }),

  // REWARDS SCREEN
  rw_title: 'Meine Belohnungen',
  rw_error: 'Belohnungen konnten nicht geladen werden',
  rw_level: (n) => `Level ${n}`,
  rw_confirmed_referrals: (n) =>
    plural('de', n, { one: '{n} bestätigte Empfehlung', other: '{n} bestätigte Empfehlungen' }),
  rw_next_level_section: (n) =>
    plural('de', n, { one: 'NÄCHSTES LEVEL — {n} Empfehlung', other: 'NÄCHSTES LEVEL — {n} Empfehlungen' }),
  rw_to_level: (level, target) => `bis Level ${level}: ${target}`,
  rw_max_level: 'Maximales Level erreicht!',
  rw_badges_section: 'ABZEICHEN',
  rw_formats_section: 'BOX-FORMATE',

  // QUESTION CARD
  qcard_status_new: 'Neu',
  qcard_status_hidden: 'Versteckt',
  qcard_status_answered: 'Beantwortet',
  qcard_moderation_flagged: 'Achtung: verdächtige Nachricht',
  qcard_answer_btn: 'Antworten',
  qcard_answer_send: 'Senden',
  qcard_share_btn: 'Teilen',
  qcard_hide_btn: 'Verstecken',
  qcard_show_btn: 'Anzeigen',
  qcard_report_btn: 'Melden',
  qcard_block_btn: 'Blockieren',
  qcard_unblock_btn: 'Entsperren',
  qcard_report_reason_label: 'Meldegrund auswählen:',
  qcard_reason_spam: 'Spam',
  qcard_reason_harassment: 'Belästigung',
  qcard_reason_sexual: 'Sexueller Inhalt',
  qcard_reason_other: 'Sonstiges',
  qcard_error_hide: 'Sichtbarkeit konnte nicht geändert werden.',
  qcard_error_report: 'Meldung konnte nicht gesendet werden.',
  qcard_error_block: 'Absender konnte nicht blockiert werden.',
  qcard_report_done: 'Meldung gesendet — danke.',
  qcard_block_done: 'Absender blockiert.',
  qcard_unblock_done: 'Absender entsperrt.',

  // ERRORS (common humanized error messages)
  err_network: 'Keine Verbindung zum Server. Prüfe dein Internet und versuche es erneut.',
  err_server_unavailable: 'Server ist vorübergehend nicht verfügbar, bitte versuche es später.',
  err_internal: 'Etwas ist bei uns schiefgelaufen. Wir schauen schon nach — versuche es später.',
  err_bad_request: 'Bitte überprüfe die eingegebenen Daten.',
  err_generic: 'Aktion konnte nicht abgeschlossen werden, bitte versuche es später.',
  err_schema: 'Datenfehler. Versuche, die App zu aktualisieren.',
  share_story_link_premium_note:
    'Ein klickbarer Link in Stories erfordert Telegram Premium. Ohne ihn können dich deine Freunde trotzdem finden — dein Nutzername ist auf der Karte sichtbar.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Zugriffsfehler',
  auth_error_desc:
    'Authentifizierung fehlgeschlagen. Bitte schließe die Mini App und öffne sie erneut über Telegram.',

  // REWARD TOAST
  reward_toast_title: 'Neue Belohnung!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Fragen',
  tab_leaderboard: 'Rangliste',
  tab_rewards: 'Belohnungen',
  tab_settings: 'Einstellungen',

  // SETTINGS SCREEN
  settings_title: 'Einstellungen',
  settings_section_general: 'Allgemein',
  settings_notifications: 'Benachrichtigungen über neue Fragen',
  settings_notifications_hint: 'Der Bot schreibt dir, wenn jemand eine Frage stellt.',
  settings_notifications_error: 'Benachrichtigungseinstellung konnte nicht gespeichert werden.',
  settings_language: 'Sprache',
  settings_language_error: 'Sprache konnte nicht geändert werden. Bitte versuche es erneut.',
  settings_section_about: 'Über die App',
  settings_version: 'Version',

  // CODE ENTRY (work-020)
  code_modal_title: 'Story-Links sind Premium-only',
  code_modal_explain:
    'Telegram gibt nur Premium-Abonnenten einen klickbaren Story-Link. Füge stattdessen deinen Code zur Story hinzu — Zuschauer tippen ihn in der App ein und stellen dir eine anonyme Frage.',
  code_modal_your_code: 'Dein Code',
  code_modal_copy: 'Code kopieren',
  code_modal_copied: 'Kopiert',
  code_modal_share_btn: 'In Story teilen',
  code_modal_loading: 'Code wird geladen…',
  code_modal_error: 'Code konnte nicht geladen werden. Versuche es später.',
  ask_code_title: 'Code eingeben',
  ask_code_desc:
    'Aus einer Story gekommen? Finde den Code darin (z.B. 1234) und gib ihn unten ein.',
  ask_code_placeholder: 'Code aus der Story',
  ask_code_find: 'Suchen',
  ask_code_not_found: 'Code nicht gefunden. Prüfe die Ziffern und versuche es erneut.',
  ask_code_invalid: 'Der Code besteht aus 4 Ziffern.',
  code_onboarding_header: 'Aus einer Story gekommen?',
  code_onboarding_text: 'Gib den Code eines Freundes ein, um ihm eine anonyme Frage zu stellen.',
  code_onboarding_action: 'Code eingeben',
  settings_ask_by_code: 'Per Code fragen',
  settings_my_code_title: 'Dein Story-Code',
  settings_my_code_hint:
    'Schreib diesen Code in deine Story — Zuschauer tippen ihn ein, um dir eine anonyme Frage zu stellen. Telegram gibt klickbare Story-Links nur Premium-Abonnenten.',
  settings_my_code_rotate: 'Neuen Code holen',
  settings_my_code_rotating: 'Wird aktualisiert…',
  settings_my_code_done: 'Code aktualisiert',
  settings_my_code_error: 'Code konnte nicht geladen werden.',
  settings_my_code_rotate_confirm_title: 'Code ändern?',
  settings_my_code_rotate_confirm_desc:
    'Dein alter Code funktioniert sofort nicht mehr. Wer ihn in deiner Story gesehen hat, kann dich dann nicht mehr erreichen. Ändere ihn nur, wenn dich jemand mit Spam nervt.',
  settings_my_code_rotate_confirm_action: 'Code ändern',

  // BOT
  bot_greeting: (name) => (name ? `Hallo, ${name}! 👋` : 'Hallo! 👋'),
  bot_onboarding:
    'Das ist VeylMe — anonyme Fragen.\n\n' +
    'Öffne die Mini App, veröffentliche eine Karte „Stell mir anonym eine Frage" in deiner Story — ' +
    'und erhalte anonyme Fragen direkt hier.\n\n' +
    '⚠️ 18+. Sei respektvoll: Mobbing, Drohungen und verbotene Inhalte ' +
    'sind nicht erlaubt. Anonymität ≠ Straffreiheit — Verstöße gehen an die Moderation.',
  bot_open_btn: 'VeylMe öffnen',
  notify_answer_btn: 'Antworten',
  bot_invite_text:
    'Jemand hat einen VeylMe-Link geteilt.\n\n' +
    'Öffne die Mini App, um eine anonyme Frage zu stellen:',
  bot_invite_btn: 'Anonym fragen',

  // WORK-027 i18n sweep
  tagline: 'Stell mir anonym eine Frage',
  share_ask_action: 'Fragen',
  share_answered_text: 'Ich habe eine anonyme Frage beantwortet 👀',
  err_not_in_telegram: 'Die Mini App läuft nicht in Telegram. Bitte starte die App neu.',
  badge_viral_starter: 'Viraler Start',
  badge_storyteller: 'Geschichtenerzähler',
  badge_loop_master: 'Loop-Meister',
  theme_confession: 'Geständnisse',
  theme_guesswho: 'Wer ist es?',
  rw_format_named: (name) => `Format „${name}"`,
  card_label_question: 'Frage',
  card_label_answer: 'Antwort',
  card_invite_subtitle: 'anonym, ohne Anmeldung',
  card_code_hint: 'CODE IN DER APP EINGEBEN',
  share_msg_title: (brand) => `${brand} · Anonyme Fragen`,
  notify_new_question: '🔔 Jemand hat dir eine anonyme Frage gestellt',
  notify_unanswered_reminder: (n) =>
    plural('de', n, { one: '🔔 Du hast {n} unbeantwortete Frage', other: '🔔 Du hast {n} unbeantwortete Fragen' }),
  notify_ban_permanent: 'dauerhaft',
  notify_ban_until: (date) => `bis ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ Du bist ${untilPhrase} in VeylMe gesperrt. Zu viele Empfänger haben deine Nachrichten gemeldet.\nWenn du glaubst, dass dies ein Fehler ist, kannst du in der App Einspruch einlegen.`,
  notify_warning_msg:
    '⚠️ Mehrere Empfänger haben deine Nachrichten gemeldet. Noch ein paar mehr und du wirst in VeylMe gesperrt.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'Meine Fragen',
  my_questions_empty_title: 'Du hast noch keine Frage gestellt',
  my_questions_empty_desc: 'Stelle eine Frage in einer Box — die Antwort erscheint hier.',
  my_questions_loading: 'Prüfe auf Antwort…',
  my_questions_waiting: 'Wartet auf Antwort',
  my_questions_answer_label: 'Antwort',
  settings_my_questions: 'Meine Fragen',
  ask_sent_find_reply_hint: 'Die Antwort findest du später unter «Meine Fragen».',
  inbox_story_nonpremium_hint: 'Ein Story-Link ist ohne Telegram Premium nicht anklickbar, deshalb zeigen wir einen Code — Teilen im Chat ist zuverlässiger.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Dein Telegram-Zugang ist abgelaufen',
  session_expired_desc: 'Telegram stellt der App den Zugang nur einmal beim Start aus, und dieser ist bereits abgelaufen. Öffne die App erneut — den begonnenen Text haben wir gespeichert.',
  session_expired_desc_no_storage: 'Dein Telegram-Zugang ist abgelaufen, die App muss neu geöffnet werden. Wir konnten den eingegebenen Text nicht speichern — kopiere ihn, bevor du gehst.',
  session_expired_reopen: 'Erneut öffnen',
  session_expired_stuck_title: 'Telegram hat denselben alten Zugang ausgegeben',
  session_expired_stuck_desc: 'Schließe die App über das Bot-Menü vollständig und öffne sie erneut — dann stellt Telegram einen neuen Zugang aus.',
  session_auth_failed_title: 'Anmeldung konnte nicht bestätigt werden',
  session_auth_failed_desc: 'Telegram hat die Anmeldung in der App nicht bestätigt. Schließe die App und öffne sie erneut aus dem Chat mit dem Bot.',
  session_expired_manual_close: 'Die App kann sich hier nicht selbst schließen — schließe sie selbst und öffne sie erneut aus dem Chat mit dem Bot.',
  session_expiring_soon: 'Dein Telegram-Zugang läuft bald ab. Öffne die App erneut, damit nichts verloren geht.',
  my_questions_check_failed: 'Antworten konnten nicht geprüft werden. Versuche es später erneut.',
  settings_notifications_load_error: 'Die Einstellung konnte nicht geladen werden.',
};
